module.exports = __webpack_public_path__ + "img/pr-9.16954f98.png";